"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import AuditFlagEditor from "./audit_flag_editor";
import "classnames";
import reactUtils from "../../react_utils";
import Api from "../../api/api";
import DocumentBrowser from "../react_document_browser";
import {
  GroupedDocumentBrowserModel,
  UngroupedGroupCopyCreator
} from "../grouped_document_browser_model";
import WaitingSpinner from "../../components/waiting_spinner";
const bem = reactUtils.makeBem("factor-invoice");
function overriddenFlags() {
  return Api.Account.overriddenAuditFlags();
}
function documentBrowserModel(props) {
  return new GroupedDocumentBrowserModel(
    new UngroupedGroupCopyCreator(props.model),
    () => false,
    void 0
  );
}
function transportationClient(state) {
  return state.factorInvoice && state.factorInvoice.carrier && state.factorInvoice.carrier.transportation_client;
}
function cancel(props, event) {
  event.preventDefault();
  event.stopPropagation();
  props.onCancel();
}
export default React.createClass({
  getInitialState() {
    return {
      auditFlags: this.props.auditFlags,
      saving: false
    };
  },
  render() {
    return /* @__PURE__ */ jsx(WaitingSpinner, { when: this.state.saving, children: /* @__PURE__ */ jsxs("div", { className: bem("__audit-review"), children: [
      /* @__PURE__ */ jsx(
        AuditFlagEditor,
        {
          flags: this.state.auditFlags,
          compact: true,
          transportationClient: transportationClient(this.state),
          overriddenFlags: overriddenFlags(),
          onFlagUpdate: this.updateAuditFlags
        }
      ),
      /* @__PURE__ */ jsxs("div", { className: bem("__audit-review-actions"), children: [
        /* @__PURE__ */ jsx("button", { className: "button--progress", onClick: this.finish, children: "Save Flags and Continue" }),
        "\xA0",
        /* @__PURE__ */ jsx(
          "button",
          {
            className: "button--cancel",
            onClick: (event) => cancel(this.props, event),
            children: "Cancel"
          }
        )
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "row", children: [
        /* @__PURE__ */ jsx("div", { className: "column small-5", children: /* @__PURE__ */ jsx(
          DocumentBrowser,
          {
            model: documentBrowserModel(this.props),
            allowsEditing: false,
            allowsEditingPodStatus: false,
            location: this.props.location,
            toggleDocumentData: this.toggleDocumentData,
            collapseSingleGroup: true
          }
        ) }),
        /* @__PURE__ */ jsx("div", { className: "column small-5", children: /* @__PURE__ */ jsx(
          DocumentBrowser,
          {
            model: documentBrowserModel(this.props),
            allowsEditing: false,
            allowsEditingPodStatus: false,
            location: this.props.location,
            toggleDocumentData: this.toggleDocumentData,
            collapseSingleGroup: true
          }
        ) })
      ] })
    ] }) });
  },
  updateAuditFlags(flags) {
    this.setState({ auditFlags: flags });
  },
  finish(event) {
    this.setState({ saving: true }, () => {
      return Api.FactorInvoices.create({
        audit_flags: this.state.auditFlags,
        factor_invoice: this.props.factorInvoice,
        documents: this.props.documentIds
      }).then(this.props.onContinue);
    });
  }
});
